import React, { useEffect, useRef } from "react";
import { Container, Row, Card } from 'react-bootstrap';

import 'react-image-lightbox/style.css'; // This only needs to be imported once in your app

import { useDispatch, useSelector } from "react-redux";

import { portfolioActions } from "../../../_actions";

import Spinner from "../Spinner";

import "./PortfoliosList.css";

const PortfoliosList = (props) => {
  const portfolios = useSelector((state) => state.portfolios);
  const loading = useSelector((state) => state.portfolios.loading);
  const dispatch = useDispatch();

  const portfolioListData = portfolios.items ? portfolios.items : [];

  const mounted = useRef();

  useEffect(() => {
    // only on componentDidMount event
    if (!mounted.current) {
      mounted.current = true;
      dispatch(portfolioActions.getAll());
    } else {
      // do componentDidUpate logic
    }
  }, [dispatch]);

  const onSelectPortfolioItem = (item) => {
    window.location.href='/portfolioitem/' + item.id;
  };

  const listItems = portfolioListData.map((item, index) => {
    const { ...itemData } = item;  
    return (
      <Card className="portfolio-list-item"
        style={{width:'21rem', marginRight:'30px', marginBottom:'30px'}}
        as="a"
        onClick={()=>onSelectPortfolioItem(item)}
        key={index} >
        <Card.Img variant="top"
          src={require("../../../static/images/portfolioitems/thumbnails/"+itemData.primaryImageFileName)}
          style={{height:"240px"}}
          alt={itemData.name}
        />
      </Card>
    );
  });

  if (loading) {
    return <Spinner />;
  }

  return (
    <Container className="portfolios-list">
      <Row className='justify-content-md-center portfolio-list-row'>
        {listItems}
      </Row>
    </Container>
  );
};

export default PortfoliosList;
